"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));
var _react = _interopRequireDefault(require("react"));
var _styled = _interopRequireWildcard(require("../styled"));
var _recompose = require("../recompose");
var _i18n = require("../i18n");
var _buttons = _interopRequireDefault(require("../buttons"));
var _FilterBox = _interopRequireDefault(require("./FilterBox"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var Wrapper = _styled.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-bottom: ", ";\n"])), (0, _styled.rem)(15));
var Filters = _styled.default.ul(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: ", ";\n  padding-left: 0;\n  flex-wrap: wrap;\n  width: 100%;\n  list-style-type: none;\n  > div {\n    width: 100%;\n    margin-bottom: ", ";\n  }\n  ", ";\n"])), (0, _styled.ifProp)('showFilter', 'flex', 'none'), (0, _styled.rem)(15), function (props) {
  return props.theme.media.min.md(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteralLoose2.default)(["\n    display: flex;\n    flex-wrap: nowrap;\n    width: auto;\n    > div {\n      width: auto;\n      height: ", ";\n      z-index: 2;\n      margin-right: ", ";\n    }\n  "])), (0, _styled.rem)(40), (0, _styled.rem)(10));
});
var StyledButton = (0, _styled.default)(_buttons.default)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n"])), function (props) {
  return props.theme.media.min.md(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteralLoose2.default)(["\n    display: none;\n  "])));
});
var Label = (0, _i18n.withTranslation)('app.product')(function (props) {
  return /*#__PURE__*/_react.default.createElement("span", props);
});
var FilterLabel = (0, _i18n.withTranslation)('app.filter')(function (props) {
  return /*#__PURE__*/_react.default.createElement("span", props);
});
var flattenOptions = function flattenOptions(options) {
  var flatOptions = [];
  options.forEach(function (option) {
    if (!option.value) {
      flatOptions.push(option);
    } else {
      var char = option.splitChar || ',';
      option.value.split(char).forEach(function (item) {
        var match = flatOptions.find(function (flatOption) {
          return flatOption.value.trim() === item.trim();
        });
        if (!match) {
          flatOptions.push({
            value: item,
            enabled: option.enabled
          });
        } else if (option.enabled) {
          match.enabled = true;
        }
      });
    }
  });
  return flatOptions;
};
var FilterList = function FilterList(_ref) {
  var options = _ref.options,
    updateFilter = _ref.updateFilter,
    activeFilter = _ref.activeFilter,
    showFilter = _ref.showFilter,
    toggleFilter = _ref.toggleFilter,
    className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(StyledButton, {
    block: true,
    onClick: toggleFilter
  }, /*#__PURE__*/_react.default.createElement(FilterLabel, {
    intlKey: showFilter ? 'close_filter' : 'open_filter'
  })), /*#__PURE__*/_react.default.createElement(Filters, {
    showFilter: showFilter,
    className: className,
    "data-cy": "FilterList"
  }, options.map(function (option) {
    return /*#__PURE__*/_react.default.createElement(_FilterBox.default, {
      key: option.key,
      options: flattenOptions(option.options),
      selected: activeFilter[option.key],
      select: function select(value) {
        return updateFilter(option.key, value);
      }
    }, /*#__PURE__*/_react.default.createElement(Label, {
      intlKey: option.key
    }, option.key.replace('features.', '')));
  })));
};
FilterList.defaultProps = {
  className: ''
};
var _default = exports.default = (0, _recompose.compose)((0, _recompose.withState)('showFilter', 'setShowFilter', false), (0, _recompose.withHandlers)({
  toggleFilter: function toggleFilter(_ref2) {
    var setShowFilter = _ref2.setShowFilter;
    return function () {
      return setShowFilter(function (showFilter) {
        return !showFilter;
      });
    };
  }
}))(FilterList);